import { render, staticRenderFns } from "./PlayerRestorationsTable.vue?vue&type=template&id=2e8f038a&scoped=true&"
import script from "./PlayerRestorationsTable.vue?vue&type=script&lang=js&"
export * from "./PlayerRestorationsTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRestorationsTable.vue?vue&type=style&index=0&id=2e8f038a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f038a",
  null
  
)

export default component.exports